import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import getRoles from '../getRoles.api';
import Results from './Results';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    }
}));

const RoleList = () => {
    const classes = useStyles();
    const rolesData = getRoles();
    const title = 'Role List';

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="Users" title={title} action={{
                permission: 'role.create',
                route: '/roles/new',
                label: 'Add Role',
            }}/>
            <LoadingOverlay loading={rolesData.loading}>
                {rolesData.data && rolesData.data.roles && (
                    <Results
                        className={classes.results}
                        roles={rolesData.data.roles}
                    />
                )}
            </LoadingOverlay>
        </Page>
    );
};

export default RoleList;
